/* unplugin-vue-components disabled */import { render } from "./ZoomModal.vue?vue&type=template&id=724015de&ts=true"
import script from "./ZoomModal.vue?vue&type=script&lang=ts"
export * from "./ZoomModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__